export default "__VITE_ASSET__WtaDOzTW__"